import { MantineThemeOverride, DEFAULT_THEME } from "@mantine/core"

const koneBlue = "#0071B9"

const blue = DEFAULT_THEME.colors?.blue
blue[0] = "#E6F3FF" // alert blue
blue[6] = koneBlue // button bg
blue[7] = "#3d9edb" // button bg over

const gray = DEFAULT_THEME.colors?.gray
gray[1] = "#F5F6F7"
gray[2] = "#EEF0F1"

const green = DEFAULT_THEME.colors?.green
green[0] = "#E6F9EB" // alert green
green[6] = "#00BA34" // alert green icon

const theme: MantineThemeOverride = {
  colors: {
    blue,
    gray,
    green
  },
  fontFamily: "KoneFont, 'Microsoft YaHei','HeiTi SC', -apple-system, 'DroidSansFallback', sans-serif",
  headings: {
    fontFamily: "KoneFont, 'Microsoft YaHei','HeiTi SC', -apple-system, 'DroidSansFallback', sans-serif",
    fontWeight: 400,
    sizes: {
      h1: { fontSize: 36 },
      h2: { fontSize: 28 },
      h3: { fontSize: 18 },
    },
  },
}

export default theme